import { createSelector } from 'reselect'

import { selectGeneralReportsState } from './selectGeneralReportsState'

export const selectGeneralReportSelectedFYear = createSelector(
  [selectGeneralReportsState],
  ({ selectedFYear }) => selectedFYear
)
